// Section 18: School subjects policy. Any two of the job skills plus Literacy, per year
// (structured value). Section 11: students gain 0.25 per season in each subject their teacher can
// teach; Literacy counts towards the `literate` flag (8 seasons).
// Default: config.policies.defaults.schoolSubjects.
import type { Config } from '../../config';
import { noChangeCost } from '../../core/content-helpers';
import { hasBuilding, isChild, peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';

export function schoolSubjects(config: Config) {
  const skills = Object.keys(config.jobs).filter((j) => j !== 'rest');

  return definePolicy({
    id: 'schoolSubjects',
    label: 'School subjects',
    section: 'S18',
    group: 'education',
    options: null,
    default: config.policies.defaults.schoolSubjects,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    // M6: the year's two subjects and who studies them.
    affects(ctx, value) {
      const [first, second] = value;
      const from = config.skills.schoolAgeFromYears * config.people.seasonsPerYear;
      const students = peopleSorted(ctx.state).filter(
        (p) => isChild(config, p) && p.ageSeasons >= from,
      ).length;
      const key = hasBuilding(ctx.state, 'school')
        ? 'policy.schoolSubjects.subjects'
        : 'policy.schoolSubjects.no-school';
      return [{ key, params: { first, second, students } }];
    },
    validate(_ctx, value) {
      const valid = (s: string): boolean => s === 'literacy' || skills.includes(s);
      // A Decision arrives from outside, so check the tuple's shape at runtime too.
      const list: readonly string[] = value;
      if (list.length === 2 && list[0] !== list[1] && list.every(valid)) return null;
      return {
        path: 'policies.schoolSubjects',
        code: 'invalid_option',
        message: 'Choose two different subjects: job skills or Literacy.',
      };
    },
  });
}
